import { generateCarleadCreationConfig } from '@wkda/funnel-utils';
import { DEFAULT_CARLEAD_CONFIGS } from '@wkda/marketing-components';

export default generateCarleadCreationConfig({
  ...DEFAULT_CARLEAD_CONFIGS['de-DE'],
  marketingConfig: {
    googleRatingsSingleStar: true,
    googleRatingsReviewsAs: 'link',
    hasGoogleReviewsSection: true,
    randomGoogleReviewsCount: 5,
    showGoogleReviewsHeaderNav: true,
  },
});
